import * as focusTrap from 'focus-trap';
import DonorForm from './Form';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

// Create a new DonorForm instance for each form on the page.
const donorForms = document.querySelectorAll('.donor-form__container:not(.leads-form)');
if (donorForms && donorForms.length) {
  donorForms.forEach((item) => {
    new DonorForm(item);
  });
}

// Get the modal element
const triggers = document.querySelectorAll('#donor-modal__trigger, .donor-modal__close');
const modal = document.querySelector('.donor-form__modal');

// Create a focus trap instance for the modal
const trap = focusTrap.createFocusTrap(modal, {initialFocus: false, allowOutsideClick: true});
let modalOpen = false;

// Get all content blocks that contain a donor form
const contentBlockFormScrollTriggers = document.querySelectorAll('.content-blocks__scroll-to-donor-form');
const contentBlockForms = document.querySelectorAll('.content-blocks--donor-form');

/**
 * Add event listeners to all modal-triggers.
 */
triggers.forEach((item) => {
  item.addEventListener('click', toggleModal);
});

/**
 * Toggle DonorForm modal.
 */
function toggleModal () {
  // console.log('modalOpen');
    if (modalOpen) {
      // console.log('close modal');
        modal.classList.remove('open');
        modalOpen = false;
        trap.deactivate();
        enableBodyScroll(modal);
    } else {
      // console.log('open modal');
        modal.classList.add('open');
        modalOpen = true;
        trap.activate();
        disableBodyScroll(modal, {reserveScrollBarGap: true});
    }
}

/**
 * If there are content blocks that contain a donor form, add event listeners to the buttons that scroll to them.
 */
if (contentBlockFormScrollTriggers && contentBlockFormScrollTriggers.length && contentBlockForms && contentBlockForms.length) {
  contentBlockFormScrollTriggers.forEach((item) => {
    const button = item.querySelector('.button');
  
    button.addEventListener('click', (e) => {
      // Find the closest donor form content block after this button
      let nextContentBlock = null;
      let currentContentBlock = item;

      while(currentContentBlock.nextElementSibling && !nextContentBlock) {
        currentContentBlock = currentContentBlock.nextElementSibling;
        if (currentContentBlock.classList.contains('content-blocks--donor-form')) {
          nextContentBlock = currentContentBlock;
        }
      }

      // Scroll to the top of the content block
      window.scrollTo({
        top: parseInt(nextContentBlock.getBoundingClientRect().top + window.scrollY - 100),
        behavior: 'smooth'
      });

      setTimeout(() => {
        // Focus the first input in the form after the scroll animation is complete
        nextContentBlock.setAttribute('tabindex', '-1');
        nextContentBlock.focus();
        nextContentBlock.removeAttribute('tabindex');

        nextContentBlock = null;
      }, 1000);

    });
  });
}
